import { Injectable } from '@angular/core';
import { CanMatch, GuardResult, MaybeAsync, Route, UrlSegment } from '@angular/router';
import { AppConfigService } from '../../app-config.service';

@Injectable({ providedIn: 'root' })
export class AccessIsSuperAdminGuard implements CanMatch {
  constructor(private readonly configService: AppConfigService) {}

  canMatch(_route: Route, _segments: UrlSegment[]): MaybeAsync<GuardResult> {
    return this.configService.config.isSuperAdmin;
  }
}
